<div class="modal-header">
  <h4 class="modal-title">Select an Address</h4>
  <aurora-icon-button class="close" type="button" (click)="cancelSelection()" icon="times" size="large"></aurora-icon-button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-6">
      <sm-card title="Entered">
        <div>{{ enteredAddress.Address_Line_1 }}</div>
        <div *ngIf="enteredAddress.Address_Line_2">{{ enteredAddress.Address_Line_2 }}</div>
        <div *ngIf="enteredAddress.Address_Line_3">{{ enteredAddress.Address_Line_3 }}</div>
        <div>{{ enteredAddress.City }} {{ enteredAddress.State }} {{ enteredAddress.Zip }}</div>
        <div style="text-align: right">
          <aurora-button type="button" (click)="validationOverride()" variant="secondary">Use Entered</aurora-button>
        </div>
      </sm-card>
    </div>
    <div class="col-6">
      <div style="max-height: 400px; overflow-y: auto; padding-right: 5px">
        <sm-card *ngFor="let address of addresses; index as i" title="Validated Address">
          <div>{{ address.Address_Line_1 }}</div>
          <div *ngIf="address.Address_Line_2">{{ address.Address_Line_2 }}</div>
          <div *ngIf="address.Address_Line_3">{{ address.Address_Line_3 }}</div>
          <div>{{ address.City }} {{ address.State }} {{ address.Zip }}</div>
          <div style="text-align: right">
            <aurora-button type="button" (click)="acceptValidated(address)" variant="primary">Accept</aurora-button>
          </div>
        </sm-card>
        <sm-card *ngIf="!addresses || addresses.length == 0" title="Address Validation Failed">
          <div>Address not found.</div>
        </sm-card>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <aurora-button type="button" (click)="cancelSelection()" variant="tertiary">Cancel</aurora-button>
</div>
